// from publica documentation: https://publica-project.atlassian.net/wiki/spaces/wiki/pages/1202880513/DMA+Codes
export const US_DMA_CODES = [
  { key: '500', name: 'Portland - Auburn' },
  { key: '501', name: 'New York' },
  { key: '502', name: 'Binghamton' },
  { key: '503', name: 'Macon' },
  { key: '504', name: 'Philadelphia' },
  { key: '505', name: 'Detroit' },
  { key: '506', name: 'Boston (Manchester)' },
  { key: '507', name: 'Savannah' },
  { key: '508', name: 'Pittsburgh' },
  { key: '509', name: 'Fort Wayne' },
  { key: '510', name: 'Cleveland' },
  { key: '511', name: 'Washington DC (Hagerstown)' },
  { key: '512', name: 'Baltimore' },
  { key: '513', name: 'Flint - Saginaw - Bay City' },
  { key: '514', name: 'Buffalo' },
  { key: '515', name: 'Cincinnati' },
  { key: '516', name: 'Erie' },
  { key: '517', name: 'Charlotte' },
  { key: '518', name: 'Greensboro - High Point - Winston-Salem' },
  { key: '519', name: 'Charleston, SC' },
  { key: '520', name: 'Augusta' },
  { key: '521', name: 'Providence - New Bedford' },
  { key: '522', name: 'Columbus, GA' },
  { key: '523', name: 'Burlington - Plattsburgh' },
  { key: '524', name: 'Atlanta' },
  { key: '525', name: 'Albany, GA' },
  { key: '526', name: 'Utica' },
  { key: '527', name: 'Indianapolis' },
  { key: '528', name: 'Miami - Fort Lauderdale' },
  { key: '529', name: 'Louisville' },
  { key: '530', name: 'Tallahassee - Thomasville' },
  { key: '531', name: 'Tri-Cities, TN-VA' },
  { key: '532', name: 'Albany - Schenectady - Troy' },
  { key: '533', name: 'Hartford & New Haven' },
  { key: '534', name: 'Orlando - Daytona Beach - Melbourne' },
  { key: '535', name: 'Columbus, OH' },
  { key: '536', name: 'Youngstown' },
  { key: '537', name: 'Bangor' },
  { key: '538', name: 'Rochester, NY' },
  { key: '539', name: 'Tampa - Saint Petersburg (Sarasota)' },
  { key: '540', name: 'Traverse City - Cadillac' },
  { key: '541', name: 'Lexington' },
  { key: '542', name: 'Dayton' },
  { key: '543', name: 'Springfield - Holyoke' },
  { key: '544', name: 'Norfolk - Portsmouth - Newport News' },
  { key: '545', name: 'Greenville - New Bern - Washington' },
  { key: '546', name: 'Columbia, SC' },
  { key: '547', name: 'Toledo' },
  { key: '548', name: 'West Palm Beach - Fort Pierce' },
  { key: '549', name: 'Watertown' },
  { key: '550', name: 'Wilmington' },
  { key: '551', name: 'Lansing' },
  { key: '552', name: 'Presque Isle' },
  { key: '553', name: 'Marquette' },
  { key: '554', name: 'Wheeling - Steubenville' },
  { key: '555', name: 'Syracuse' },
  { key: '556', name: 'Richmond - Petersburg' },
  { key: '557', name: 'Knoxville' },
  { key: '558', name: 'Lima' },
  { key: '559', name: 'Bluefield - Beckley - Oak Hill' },
  { key: '560', name: 'Raleigh - Durham (Fayetteville)' },
  { key: '561', name: 'Jacksonville, Brunswick' },
  { key: '563', name: 'Grand Rapids - Kalamazoo - Battle Creek' },
  { key: '564', name: 'Charleston-Huntington' },
  { key: '565', name: 'Elmira' },
  { key: '566', name: 'Harrisburg - Lancaster - Lebanon - York' },
  { key: '567', name: 'Greenville - Spartansburg - Asheville - Anderson' },
  { key: '569', name: 'Harrisonburg' },
  { key: '570', name: 'Florence - Myrtle Beach' },
  { key: '571', name: 'Fort Myers - Naples' },
  { key: '573', name: 'Roanoke - Lynchburg' },
  { key: '574', name: 'Johnstown - Altoona' },
  { key: '575', name: 'Chattanooga' },
  { key: '576', name: 'Salisbury' },
  { key: '577', name: 'Wilkes Barre - Scranton' },
  { key: '581', name: 'Terre Haute' },
  { key: '582', name: 'Lafayette, IN' },
  { key: '583', name: 'Alpena' },
  { key: '584', name: 'Charlottesville' },
  { key: '588', name: 'South Bend - Elkhart' },
  { key: '592', name: 'Gainesville' },
  { key: '596', name: 'Zanesville' },
  { key: '597', name: 'Parkersburg' },
  { key: '598', name: 'Clarksburg - Weston' },
  { key: '600', name: 'Corpus Christi' },
  { key: '602', name: 'Chicago' },
  { key: '603', name: 'Joplin - Pittsburg' },
  { key: '604', name: 'Columbia - Jefferson City' },
  { key: '605', name: 'Topeka' },
  { key: '606', name: 'Dothan' },
  { key: '609', name: 'Saint Louis' },
  { key: '610', name: 'Rockford' },
  { key: '611', name: 'Rochester - Mason City - Austin' },
  { key: '612', name: 'Shreveport' },
  { key: '613', name: 'Minneapolis - Saint Paul' },
  { key: '616', name: 'Kansas City' },
  { key: '617', name: 'Milwaukee' },
  { key: '618', name: 'Houston' },
  { key: '619', name: 'Springfield, MO' },
  { key: '622', name: 'New Orleans' },
  { key: '623', name: 'Dallas - Fort Worth' },
  { key: '624', name: 'Sioux City' },
  { key: '625', name: 'Waco - Temple - Bryan' },
  { key: '626', name: 'Victoria' },
  { key: '627', name: 'Wichita Falls & Lawton' },
  { key: '628', name: 'Monroe - El Dorado' },
  { key: '630', name: 'Birmingham (Anniston and Tuscaloosa)' },
  { key: '631', name: 'Ottumwa - Kirksville' },
  { key: '632', name: 'Paducah - Cape Girardeau - Harrisburg - Mt Vernon' },
  { key: '633', name: 'Odessa - Midland' },
  { key: '634', name: 'Amarillo' },
  { key: '635', name: 'Austin, TX' },
  { key: '636', name: 'Harlingen - Weslaco - Brownsville - McAllen' },
  { key: '637', name: 'Cedar Rapids - Waterloo & Dubuque' },
  { key: '638', name: 'Saint Joseph' },
  { key: '639', name: 'Jackson, TN' },
  { key: '640', name: 'Memphis' },
  { key: '641', name: 'San Antonio' },
  { key: '642', name: 'Lafayette, LA' },
  { key: '643', name: 'Lake Charles' },
  { key: '644', name: 'Alexandria, LA' },
  { key: '647', name: 'Greenwood - Greenville' },
  { key: '648', name: 'Champaign & Springfield - Decatur' },
  { key: '649', name: 'Evansville' },
  { key: '650', name: 'Oklahoma City' },
  { key: '651', name: 'Lubbock' },
  { key: '652', name: 'Omaha' },
  { key: '656', name: 'Panama City' },
  { key: '657', name: 'Sherman, TX - Ada, OK' },
  { key: '658', name: 'Green Bay - Appleton' },
  { key: '659', name: 'Nashville' },
  { key: '661', name: 'San Angelo' },
  { key: '662', name: 'Abilene - Sweetwater' },
  { key: '669', name: 'Madison' },
  { key: '670', name: 'Fort Smith - Fayetteville - Springdale - Rogers' },
  { key: '671', name: 'Tulsa' },
  { key: '673', name: 'Columbus - Tupelo - West Point' },
  { key: '675', name: 'Peoria - Bloomington' },
  { key: '676', name: 'Duluth - Superior' },
  { key: '678', name: 'Wichita - Hutchinson' },
  { key: '679', name: 'Des Moines - Ames' },
  { key: '682', name: 'Davenport - Rock Island - Moline' },
  { key: '686', name: 'Mobile - Pensacola (Fort Walton Beach)' },
  { key: '687', name: 'Minot - Bismarck - Dickinson' },
  { key: '691', name: 'Huntsville - Decatur (Florence)' },
  { key: '692', name: 'Beaumont - Port Arthur' },
  { key: '693', name: 'Little Rock - Pine Bluff' },
  { key: '698', name: 'Montgomery (Selma)' },
  { key: '702', name: 'La Crosse - Eau Claire' },
  { key: '705', name: 'Wausau - Rhinelander' },
  { key: '709', name: 'Tyler - Longview (Lufkin & Nacogdoches)' },
  { key: '710', name: 'Hattiesburg - Laurel' },
  { key: '711', name: 'Meridian' },
  { key: '716', name: 'Baton Rouge' },
  { key: '717', name: 'Quincy - Hannibal - Keokuk' },
  { key: '718', name: 'Jackson, MS' },
  { key: '722', name: 'Lincoln & Hastings - Kearney' },
  { key: '724', name: 'Fargo - Valley City' },
  { key: '725', name: 'Sioux Falls (Mitchell)' },
  { key: '734', name: 'Jonesboro' },
  { key: '736', name: 'Bowling Green' },
  { key: '737', name: 'Mankato' },
  { key: '740', name: 'North Platte' },
  { key: '743', name: 'Anchorage' },
  { key: '744', name: 'Honolulu' },
  { key: '745', name: 'Fairbanks' },
  { key: '746', name: 'Biloxi - Gulfport' },
  { key: '747', name: 'Juneau' },
  { key: '749', name: 'Laredo' },
  { key: '751', name: 'Denver' },
  { key: '752', name: 'Colorado Springs - Pueblo' },
  { key: '753', name: 'Phoenix' },
  { key: '754', name: 'Butte - Bozeman' },
  { key: '755', name: 'Great Falls' },
  { key: '756', name: 'Billings' },
  { key: '757', name: 'Boise' },
  { key: '758', name: 'Idaho Falls - Pocatello' },
  { key: '759', name: 'Cheyenne - Scottsbluff' },
  { key: '760', name: 'Twin Falls' },
  { key: '762', name: 'Missoula' },
  { key: '764', name: 'Rapid City' },
  { key: '765', name: 'El Paso' },
  { key: '766', name: 'Helena' },
  { key: '767', name: 'Casper - Riverton' },
  { key: '770', name: 'Salt Lake City' },
  { key: '771', name: 'Yuma - El Centro' },
  { key: '773', name: 'Grand Junction - Montrose' },
  { key: '789', name: 'Tucson (Sierra Vista)' },
  { key: '790', name: 'Albuquerque - Santa Fe' },
  { key: '798', name: 'Glendive' },
  { key: '800', name: 'Bakersfield' },
  { key: '801', name: 'Eugene' },
  { key: '802', name: 'Eureka' },
  { key: '803', name: 'Los Angeles' },
  { key: '804', name: 'Palm Springs' },
  { key: '807', name: 'San Francisco - Oakland - San Jose' },
  { key: '810', name: 'Yakima - Pasco - Richland - Kennewick' },
  { key: '811', name: 'Reno' },
  { key: '813', name: 'Medford - Klamath Falls' },
  { key: '819', name: 'Seattle - Tacoma' },
  { key: '820', name: 'Portland, OR' },
  { key: '821', name: 'Bend, OR' },
  { key: '825', name: 'San Diego' },
  { key: '828', name: 'Monterey - Salinas' },
  { key: '839', name: 'Las Vegas' },
  { key: '855', name: 'Santa Barbara - Santa Maria - San Luis Obispo' },
  { key: '862', name: 'Sacramento - Stockton - Modesto' },
  { key: '866', name: 'Fresno - Visalia' },
  { key: '868', name: 'Chico - Redding' },
  { key: '881', name: 'Spokane' },
];
